import http from '@/utils/http';

export default {
	list: data => http({ url: '/api/admin/v1/order/list', data }),
	export: data => http({ url: '/api/admin/v1/order/export', data }),
	detail: data => http({ url: '/api/admin/v1/order/detail', data }),
	confirm: data => http({ url: '/api/admin/v1/order/confirm', data, tip: true }),
	close: data => http({ url: '/api/admin/v1/order/close', data, tip: true }),
};
